let lenis = null;

export const setLenis = (instance) => {
  lenis = instance;
};

export const scrollToId = (hash) => {
  const el = document.querySelector(hash);
  if (!el) return;
  if (lenis) lenis.scrollTo(el, { offset: -64, duration: 1.5 });
  else el.scrollIntoView({ behavior: "smooth" });
};
